export default function transactionsStockComponent() {
    return {
        initTransactionsStocks(authID = null) {
            DatatableTransactionsStocks();
        },

        filterTransactionsStocks() {
            DatatableTransactionsStocks();
        },

        updateDisabilityDocument(id, status, notes) {

            var data_notes = '';
            if (typeof notes === 'object' && notes !== null) {
                Object.entries(notes).forEach(([key, value]) => {
                    data_notes += `<div class="note-content"><p class="note-inner-content text-muted"><b>${key} : </b> ${value} <br></p></div>`;
                });
            }

            Swal.fire({
                title: "Are you sure ?",
                text: "You will change the status of this Document.",
                inputLabel: 'Message',
                html:
                    `<select id="swal-status" class="swal2-select form-control select2" required>
                        <option value="" disabled="">Select Status</option>
                        <option value="accountant_completed" ${status === 'accountant_completed' ? 'selected': ''}>مكتمل</option>
                        <option value="accountant_cancelled" ${status === 'accountant_cancelled' ? 'selected': ''}>ملغي</option>
                        <option value="accountant_scheduled" ${status === 'accountant_scheduled' ? 'selected': ''}>اَجل</option>
                    </select>
                    <div class="card card-body">
                    <span class="side-stick"></span>
                    <h5 class="note-title text-truncate w-100 mt-0"><i class="point fa fa-circle ml-1 font-10"></i> Notes <i class="point fa fa-circle ml-1 font-10"></i></h5>
                     ${data_notes}
                    </div>
                    <textarea id="swal-note" class="swal2-textarea ${status !== 'accountant_scheduled' ? 'd-none': ''}" placeholder="Type your Note here...">`,
                showCancelButton: true,
                confirmButtonText: "Yes, change it !",
                cancelButtonText: "No, cancel !",
                focusConfirm: false,
                onOpen: () => {
                    document.getElementById('swal-status').onchange = () => {
                        if ($('#swal-status').val() === 'accountant_scheduled') {
                            $('#swal-note').removeClass('d-none');
                        } else {
                            $('#swal-note').addClass('d-none');
                        }
                    }
                },
                preConfirm: () => {
                    return [
                        document.getElementById('swal-status').value,
                        document.getElementById('swal-note').value
                    ]
                }
            }).then((result) => {

                if (result.value) {
                    axios.post(`/api/documents/updateAccountantStatus`,{
                        documentId: id,
                        status: result.value[0],
                        notes: result.value[1],
                    })
                    .then(function (response) {
                        showSwal('successful-opperation', response.data.message);
                        DatatableDocuments();
                    }, error => {
                        showSwal('something-wrong', '');
                    });
                }

            });

        }
    }
}

function getAccountantStatusHtml(data) {
    switch(data) {
        case 'accountant_completed':
            return `<span style="background-color: green; color: white; padding: 0 6px; font-weight: bold;">خالص</span>`;
        case 'accountant_cancelled':
            return `<span style="background-color: red; color: white; padding: 0 6px; font-weight: bold;"> ملغي</span>`;
        case 'accountant_scheduled':
            return `<span style="background-color: #6042f5; color: white; padding: 0 6px; font-weight: bold;">اَجل</span>`;
        case 'active':
            return data;
        default:
            return '';
    }
}
